// src/router/guards.js
import { useAuthStore } from '@/stores/auth'
import { globalState } from '@/utils/globalState'

export const setupGlobalGuards = (router) => {
  // 全局前置守卫
  router.beforeEach(async (to, from, next) => {
    const authStore = useAuthStore()

    // 不需要认证的页面
    const publicPages = ['/auth/login', '/auth/register', '/auth/forgot-password']
    const isPublicPage = publicPages.includes(to.path)

    if (isPublicPage) {
      next()
      return
    }

    // 需要认证的页面
    if (to.meta.requiresAuth !== false) {
      // 1. 检查是否有token
      if (!authStore.isAuthenticated) {
        console.log('未认证，跳转到登录页')
        next('/auth/login')
        return
      }

      // 2. 等待用户信息初始化完成
      try {
        const user = await globalState.waitForInitialization()
        if (!user) {
          console.log('用户信息未加载，重新获取...')
          await authStore.fetchProfile()
        }

        // 3. 检查权限
        if (to.meta.requiresAdmin && !authStore.isAdmin) {
          console.log('需要管理员权限')
          next('/dashboard')
          return
        }

        next()
      } catch (error) {
        console.error('全局守卫错误:', error)
        next('/auth/login')
      }
    } else {
      next()
    }
  })

  // 全局后置守卫
  router.afterEach((to, from) => {
    // 可以在这里添加页面切换后的逻辑
  })
}